<template>
	<div>
		<div class="on-boarding-step-explanation-text heavy">Install a feature from the marketplace</div>
		<div class="on-boarding-step-explanation-text">Add a pre-made feature to your command bar by clicking below:</div>
		<div class="listing-container mt-2 display-flex flex-column">
			<div class="display-flex flex-row flex-justify-space-between">
				<div class="feature-type-description display-flex flex-row flex-align-center pl-4">
					<SIcon name="on-boarding-install-tool" class="mr-1" />
					Tool in command bar
				</div>
				<AnemicButton
					tile
					:loading="isInstalling"
					:disabled="isCompleted"
					@click="isInstalling = true"
					class="on-boarding-step-finish-step-button mt-2"
				>
					Get
				</AnemicButton>
			</div>
			<div class="display-flex flex-column width-100 height-100 flex-justify-center pl-5">
				<div class="content-title">Translate selected text</div>
				<div class="content-description">Select any text and click translate</div>
			</div>
		</div>
		<Installation
			forceInstall
			avoidRedirection
			v-if="isInstalling"
			class="installation-container"
			:installableId="commandBarExampleInstallableId"
			@installation-complete="onInstallationComplete"
		/>
	</div>
</template>

<script>
import Installation from '@/views/Installables/Installation.vue';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
export default {
	name: 'OnBoardingGetToKnowInstallTool',
	props: {
		subStepDetails: { type: Object },
		commandBarExampleInstallableId: { type: String },
	},
	components: { Installation },
	computed: {
		isCompleted() {
			return this.subStepDetails.isCompleted;
		},
	},
	methods: {
		async onInstallationComplete(installedWorkflow) {
			this.isInstalling = false;
			this.$emit('mark-step-as-done', this.subStepDetails);
			this.$toast.success('Tool successfully installed');
			ExtensionCommunicationService.announceWorkflow(installedWorkflow);
		},
	},
	created() {},
	data() {
		return { isInstalling: false };
	},
};
</script>

<style scoped lang="scss">
.heavy {
	font-weight: 600 !important;
}
.listing-container {
	height: 130px;
	background: #ffffff;
	border: 1px solid #dfdfe2;
	border-radius: 10px;
	padding-right: 10px;
}
.feature-type-description {
	width: 250px;
	height: 35px;
	background: #f9fafc;
	border: 1px solid #f4f5f6;
	border-radius: 10px 0px 30px 0px;
	font-size: 11px;
	letter-spacing: 0.14px;
	color: #444444;
}
.content-title {
	font-size: 16px;
	color: #444444;
	font-weight: medium;
	letter-spacing: 0.21px;
}
.content-description {
	font-size: 14px;
	color: #8f95aa;
}
.installation-container {
	width: 0px;
	height: 0px;
	overflow: hidden;
}
</style>
